import React from "react";
import { flash } from "./lib";
import { StepShell } from "./FlowKit";

export const StepManifest = ({ p, update, go }) => {
  const [note, setNote] = React.useState("");
  const three = p.three || ["", "", ""];
  const setOne = (i, v) => update({ three: three.map((x, j) => (j === i ? v : x)) });
  const next = () => {
    const items = three.map((x) => x.trim()).filter(Boolean);
    if (!items.length) return flash(setNote, "Name at least one first.");
    const prev = Object.fromEntries(p.desires.map((d) => [d.x, d.y]));
    update({ desires: items.map((x) => ({ x, y: prev[x] || "" })), manifestText: items.join("\n") });
    go(2);
  };
  return (
    <StepShell n={1} label="Clarity of your vision" title="What are three things you are manifesting in life right now?">
      <p>Get specific.</p>
      <div className="three-list">
        {three.map((v, i) => (
          <div className="three-row" key={i}>
            <span>0{i + 1}</span>
            <input className="line-input" value={v} onChange={(e) => setOne(i, e.target.value)} placeholder="I am calling in..." data-testid={`manifest-input-${i}`} />
          </div>
        ))}
      </div>
      <button className="mono-btn release-btn" onClick={next} data-testid="step1-continue-btn">{p.stage > 1 ? "Update my list" : "Continue"}</button>
      <div className="save-note" data-testid="step1-note">{note}</div>
    </StepShell>
  );
};

export const StepFeel = ({ p, update, go }) => {
  const setY = (i, y) => update({ desires: p.desires.map((d, j) => (j === i ? { ...d, y } : d)) });
  const setX = (i, x) => update({ desires: p.desires.map((d, j) => (j === i ? { ...d, x } : d)) });
  const remove = (i) => update({ desires: p.desires.filter((_, j) => j !== i) });
  const add = () => update({ desires: [...p.desires, { x: "", y: "" }] });
  const ready = p.desires.length > 0 && p.desires.every((d) => d.x.trim() && d.y.trim());

  return (
    <StepShell n={2} label="Authenticity" title="What are you hoping each one will make you feel, in the moment?">
      <p>The feeling is available in the moment. That's the real root of what we are trying to create.</p>
      <div className="feel-list">
        {p.desires.map((d, i) => (
          <div className="feel-row" key={i} data-testid={`feel-row-${i}`}>
            <input className="feel-x" value={d.x} onChange={(e) => setX(i, e.target.value)} placeholder="Something I'm creating" data-testid={`desire-input-${i}`} />
            <input className="feel-y" value={d.y} onChange={(e) => setY(i, e.target.value)} placeholder="I hope it makes me feel..." data-testid={`feeling-input-${i}`} />
            <button className="evidence-del feel-del" onClick={() => remove(i)} aria-label="Remove" data-testid={`desire-remove-${i}`}>&times;</button>
          </div>
        ))}
      </div>
      <button className="text-btn add-btn" onClick={add} data-testid="desire-add-btn">+ Add another</button>

      {p.desires.some((d) => d.x.trim() && d.y.trim()) && (
        <div className="because-card" data-testid="because-list">
          <div className="label">What you are really calling in</div>
          {p.desires.filter((d) => d.x.trim() && d.y.trim()).map((d, i) => (
            <p key={i} className="because-line" data-testid={`because-line-${i}`}>
              I want to create <strong>{d.x}</strong> because I want to feel <em>{d.y}</em>.
            </p>
          ))}
        </div>
      )}
      <div>
        <button className="mono-btn save-btn" disabled={!ready} onClick={() => go(3)} data-testid="step2-continue-btn">
          {ready ? "Continue" : "Name a feeling for each"}
        </button>
      </div>
    </StepShell>
  );
};
